import { default as axios } from '../utils/axios.instances' // eslint-disable-line

const axiosInstance = axios.getSTAxios() // eslint-disable-line

export default {
  async loadGallery () {
    return new Promise((resolve, reject) => {
      axiosInstance.get('/stc/gallery/?limit=1000&offset=0&ordering=-created_at&is_archived=false', {}).then((res) => {
        resolve(res.data.results)
      }).catch((err) => {
        reject(err)
      })
    })
  }

}
